import type { Sequence } from "./Sequence"

/**
 * Union type for sync or async sequences.
 *
 * Accepts both AsyncIterable (async generators) and sync Iterable.
 * Used throughout library for streaming operations.
 *
 * @example
 * ```ts
 * const sync: AsyncSequence<number> = [1, 2, 3]
 * const async: AsyncSequence<number> = async function*() { yield 1 }()
 * ```
 */
export type AsyncSequence<T> = AsyncIterable<T> | Sequence<T>
